import React, { useEffect, useState } from "react";
import "./CmSearchSuggestionsPage.Styles.css";
import { Grid, Container, Box, CircularProgress } from "@mui/material";
import MiniDrawer from "../../Component/newNavBarCM/newNavBar";
import Select from "react-select";
import TableComponentForSearchSuggestions from "./TableComponentForSearchSuggestions";
import { getSearchSuggestionsForCMRecords, getSearchSuggestionsCount } from "../../API/api"
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../Action";
import { useLocation } from "react-router-dom";
import { Tooltip } from "@mui/material";
import VizParagraph from "../../Component/VizParagraph/VizParagraph";
import moment from "moment";
import { convertEpochToTimestamp } from "../../utils";
import Layout from '../../NewComponent/LayoutCM/Layout';


export default function CmSearchSuggestionsPage() {
	const dispatch = useDispatch();
	const currentPath = useLocation();
	const { SearchSuggestionsDataCM, searchSuggestionsDataCountCM, getLoadingStatusForSearchSuggestions, updatePageNoInSearchSuggestions, getGeoLevelIdInURL, getGeoLevelValueInURL,getCheckForDeletedItems,deleteQuestionInSearchSuggestions,clearDeletedItemsInSearchArray } = bindActionCreators(Actions, dispatch);
	const searchSuggestionsReducer = useSelector((state) => state.searchSuggestionsCM);
	const state = useSelector(state=>state.cmRoot);
	const [date, setDate] = useState(Date.now());
	const [fromNowTime, setFromTime] =React.useState(moment().fromNow())
	// console.log(country[0].value, region, "country region check");

	const momentit = (stime) => {
		if (Number(Date.now()) - Number(stime) < 259200000) {
			return moment(new Date(Number(stime))).fromNow();
		} else {
			return moment(convertEpochToTimestamp(stime)).format("ll");
		}
	};

	const customStyles = {
		control: (baseStyles, state) => ({
			...baseStyles,
			fontSize: '14px',
			height: 32,
			minHeight: 28,
			marginTop: 0,
			borderColor: 'lightgrey',
		}),
		container: (styles) => ({
			...styles,
			marginTop: 0,
			flex: 1
		}),
		dropdownIndicator: (styles) => ({
			...styles,
			paddingTop: 0,
			paddingBottom: 0,
			color: "rgb(0 67 88)",
		}),
		clearIndicator: (styles) => ({
			...styles,
			paddingTop: 0,
			paddingBottom: 0,
			color: "rgb(0 67 88)",
		}),
		option: (baseStyles, state) => ({
			...baseStyles,
			backgroundColor: (state.isFocused
				? "var(--light_color_shade)"
				: "none"),
			color: state.isFocused ? "#fff" : "none",
			fontSize: '14px'
		})
	};
	useEffect(() => {
		if(searchSuggestionsReducer.isComingBack){
			return;
		}
		deleteQuestionInSearchSuggestions(null)
		getLoadingStatusForSearchSuggestions(true);
		let payloadForCMCount = {
			page: searchSuggestionsReducer.page,
			excludeEmail: searchSuggestionsReducer.excludeEmail,
			...(searchSuggestionsReducer.source === 'email') ? {excludeEmail:false} :{excludeEmail:searchSuggestionsReducer.excludeEmail},
			// geoLevelId: searchSuggestionsReducer.geoLevelId,
			// geoLevelValue: searchSuggestionsReducer.geoLevelValue,
			geoLevelId:state.selecetdRoutingValue, 
			geoLevelValue:state.selectedGeoLevel.name,
			...(searchSuggestionsReducer.isAccepted === true && { accepted: searchSuggestionsReducer.isAccepted }),
			...(searchSuggestionsReducer.source !== '' && { source: searchSuggestionsReducer.source }),
			...(searchSuggestionsReducer.fromDate !== '' && { updatedFromDate: searchSuggestionsReducer.fromDate }),
			...(searchSuggestionsReducer.tillDate !== '' && { updatedToDate: searchSuggestionsReducer.tillDate + ` 23:59:59` }),
			...(searchSuggestionsReducer.seekers !== null && searchSuggestionsReducer.seekers.length > 0 && { seekers: searchSuggestionsReducer.seekers.toString() }),
			...(searchSuggestionsReducer.experts.length > 0 && { experts: searchSuggestionsReducer.experts.toString() }),
			...(state.selectedDomainIds !='' && { domains: state.selectedDomainIds }),
			...(searchSuggestionsReducer.isEmpty && {emptySuggestions:searchSuggestionsReducer.isEmpty}),
			...(searchSuggestionsReducer.getDislikes && {rejected:searchSuggestionsReducer.getDislikes}),
			...(searchSuggestionsReducer.genAIToggle) && {genAIAnswer:searchSuggestionsReducer.genAIToggle},
			...(searchSuggestionsReducer.bestResultToggle) && {bestResults:searchSuggestionsReducer.bestResultToggle},
			...(searchSuggestionsReducer.qSubmitted) && {submitted:searchSuggestionsReducer.qSubmitted}
		}
		let payloadForCMSearchRecords = {
			page: searchSuggestionsReducer.page,
			excludeEmail: searchSuggestionsReducer.excludeEmail,
			...(searchSuggestionsReducer.source === 'email') ? {excludeEmail:false} :{excludeEmail:searchSuggestionsReducer.excludeEmail},
			// geoLevelId: searchSuggestionsReducer.geoLevelId,
			// geoLevelValue: searchSuggestionsReducer.geoLevelValue,
			geoLevelId:state.selecetdRoutingValue,
			geoLevelValue:state.selectedGeoLevel.name,
			...(searchSuggestionsReducer.isAccepted === true && { accepted: searchSuggestionsReducer.isAccepted }),
			...(searchSuggestionsReducer.source !== '' && { source: searchSuggestionsReducer.source }),
			...(searchSuggestionsReducer.fromDate !== '' && { updatedFromDate: searchSuggestionsReducer.fromDate }),
			...(searchSuggestionsReducer.tillDate !== '' && { updatedToDate: searchSuggestionsReducer.tillDate + ` 23:59:59`}),
			...( searchSuggestionsReducer.seekers.length > 0 && { seekers: searchSuggestionsReducer.seekers.toString() }),
			...(searchSuggestionsReducer.experts.length > 0 && { experts: searchSuggestionsReducer.experts.toString() }),
			...(state.selectedDomainIds !== '' && { domains: state.selectedDomainIds }),
			...(searchSuggestionsReducer.isEmpty && {emptySuggestions:searchSuggestionsReducer.isEmpty}),
			...(searchSuggestionsReducer.getDislikes && {rejected:searchSuggestionsReducer.getDislikes}),
			...(searchSuggestionsReducer.genAIToggle) && {genAIAnswer:searchSuggestionsReducer.genAIToggle},
			...(searchSuggestionsReducer.bestResultToggle) && {bestResults:searchSuggestionsReducer.bestResultToggle},
			...(searchSuggestionsReducer.qSubmitted) && {submitted:searchSuggestionsReducer.qSubmitted}
		}
		if(state.routingData.length > 0)
		{
		getCheckForDeletedItems(false)
		getSearchSuggestionsCount(payloadForCMCount).then((res) => {
			if (res===undefined) return;
			if (res.data.success === true || res.data.data !== undefined) {
				searchSuggestionsDataCountCM(res.data.data);
			}
		})
		getSearchSuggestionsForCMRecords(payloadForCMSearchRecords
		).then((res) => {
			if (res===undefined) return;
			if (res.data.data !== undefined || res.data.success) {
				SearchSuggestionsDataCM(res.data.data);
				getLoadingStatusForSearchSuggestions(false);
			}
		})
	}
	}, [searchSuggestionsReducer.page,searchSuggestionsReducer.excludeEmail, searchSuggestionsReducer.isAccepted, searchSuggestionsReducer.source, searchSuggestionsReducer.fromDate, searchSuggestionsReducer.tillDate, searchSuggestionsReducer.seekers,searchSuggestionsReducer.seekersListInfo, searchSuggestionsReducer.experts,searchSuggestionsReducer.expertsListInfo, searchSuggestionsReducer.ratings, state.selecetdRoutingValue, state.selectedGeoLevel,state.selectedDomainIds,searchSuggestionsReducer.getDislikes,searchSuggestionsReducer.isEmpty,searchSuggestionsReducer.genAIToggle,searchSuggestionsReducer.bestResultToggle,searchSuggestionsReducer.qSubmitted])
	
	return (
		<>
			<Layout>
			<div style={{width:'95%',marginLeft:'auto',marginRight:'auto'}}>
				<Grid container xs={12}  paddingTop={1}>
						{/* <div style={{display:'flex'}}>
							<div style={{fontSize:'20px'}}>
							Vizerto Search History
							</div>
							<div>
								{
									searchSuggestionsReducer.count === 0 &&
									<>
									<div className="searchSuggestionsCount">
										<span>
											0 to 0 of 0
										</span>
									</div>
									</>
								}
								{(searchSuggestionsReducer.count > 0)
									&&
									<div className="searchSuggestionsCount">
										{
											searchSuggestionsReducer.page === 0 ? <><span>1 to {searchSuggestionsReducer.searchSuggestionsData.length} of {searchSuggestionsReducer.count}</span></>
												:
												<>
													<span>
														{(searchSuggestionsReducer.page === (Math.ceil(searchSuggestionsReducer.count / 20) - 1)) ? (searchSuggestionsReducer.count - searchSuggestionsReducer.searchSuggestionsData.length) + 1 : searchSuggestionsReducer.page * searchSuggestionsReducer.searchSuggestionsData.length + 1}
														{" "}to{" "}
														{searchSuggestionsReducer.page === (Math.ceil(searchSuggestionsReducer.count / 20) - 1) ? searchSuggestionsReducer.count : ((searchSuggestionsReducer.page) * (searchSuggestionsReducer.searchSuggestionsData.length) + (searchSuggestionsReducer.searchSuggestionsData.length))}
														{" "}of{" "}{searchSuggestionsReducer.count}
													</span>
												</>
										}
									</div>
								}
						</div>
						</div> */}
					<Grid container xs={12}>
						<TableComponentForSearchSuggestions />
					</Grid>
				</Grid>
				</div>
			</Layout>
		</>
	)
}